import { render, staticRenderFns } from "./CourseSlidebar.vue?vue&type=template&id=028d2382"
import script from "./CourseSlidebar.vue?vue&type=script&lang=js"
export * from "./CourseSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports